export default class Search {
  constructor() {
    this.popup = document.getElementById('search-popup')
    this.toggle = document.querySelector('.js-search-toggle')

    if (!this.popup || !this.toggle) return

    this.input = this.popup.querySelector('.search-popup__input')
    this.closeEls = this.popup.querySelectorAll('.js-search-close')

    this.addListeners()
  }

  open() {
    this.popup.classList.add('active')
    this.popup.setAttribute('aria-hidden', 'false')
    this.toggle.setAttribute('aria-expanded', 'true')
    document.body.style.overflowY = 'hidden'

    window.setTimeout(() => {
      if (this.input) this.input.focus()
    }, 60)
  }

  close() {
    this.popup.classList.remove('active')
    this.popup.setAttribute('aria-hidden', 'true')
    this.toggle.setAttribute('aria-expanded', 'false')
    document.body.style.overflowY = 'scroll'
  }

  addListeners() {
    this.toggle.addEventListener('click', () => this.open())

    this.closeEls.forEach((el) =>
      el.addEventListener('click', () => this.close())
    )

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.popup.classList.contains('active')) {
        this.close()
      }
    })
  }
}
